import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import BackGroundImg from "../assets/background.webp"

const GetFreeConsultation = () => {
    const { t } = useTranslation();

  return (
       <div className="bg-[rgba(218,203,181,0.2)] relative p-6">
        <img src={BackGroundImg} className='absolute -z-10 h-full object-cover inset-0 w-full' alt="" loading="lazy" decoding="async" />
      <div className="container mx-auto text-center py-20 flex max-w-3xl items-center justify-center flex-col">
            <h1 className='!leading-snug text-2xl font-semibold font-Merriweather mb-10 text-[rgb(111,91,33)]'>{t('getConsultationHeading')}</h1>
            <p className='text-sm max-w-sm'>{t('consultationHeading')}</p>
                <button className='p-3 px-5 rounded-md bg-[rgb(111,91,33)] text-white mt-10'>
                <Link to='https://www.vagaro.com/artistryspanwellness' target='_blank'>
                {t('bookAppointmentBtn')}
                </Link>
                </button>
        </div>
    </div>
  )
}

export default GetFreeConsultation
